module.exports = __webpack_public_path__ + "img/Poseidon.3fd59311.jpg";